var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_c('div',{staticClass:"header-block"},[(_vm.title)?_c('div',{staticClass:"header-block_tag"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]),(!_vm.loading)?_c('div',[_c('list',{attrs:{"games":_vm.games}})],1):_c('div',{staticClass:"loading"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }